module.exports = __webpack_public_path__ + "img/con2.23d4d701.png";